/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseCHOpenIcon16Light } from './ArrowCollapseCHOpenIcon16Light';
import { ArrowCollapseCHOpenIcon16Regular } from './ArrowCollapseCHOpenIcon16Regular';
import { ArrowCollapseCHOpenIcon16Solid } from './ArrowCollapseCHOpenIcon16Solid';
import { ArrowCollapseCHOpenIcon20Light } from './ArrowCollapseCHOpenIcon20Light';
import { ArrowCollapseCHOpenIcon20Regular } from './ArrowCollapseCHOpenIcon20Regular';
import { ArrowCollapseCHOpenIcon20Solid } from './ArrowCollapseCHOpenIcon20Solid';
import { ArrowCollapseCHOpenIcon24Regular } from './ArrowCollapseCHOpenIcon24Regular';
import { ArrowCollapseCHOpenIcon24Solid } from './ArrowCollapseCHOpenIcon24Solid';
import { ArrowCollapseCHOpenIcon32Regular } from './ArrowCollapseCHOpenIcon32Regular';
import { ArrowCollapseCHOpenIcon64Regular } from './ArrowCollapseCHOpenIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseCHOpenIcon16Light,
        regular: ArrowCollapseCHOpenIcon16Regular,
        solid: ArrowCollapseCHOpenIcon16Solid,
    },
    20: {
        light: ArrowCollapseCHOpenIcon20Light,
        regular: ArrowCollapseCHOpenIcon20Regular,
        solid: ArrowCollapseCHOpenIcon20Solid,
    },
    24: {
        regular: ArrowCollapseCHOpenIcon24Regular,
        solid: ArrowCollapseCHOpenIcon24Solid,
    },
    32: {
        regular: ArrowCollapseCHOpenIcon32Regular,
    },
    64: {
        regular: ArrowCollapseCHOpenIcon64Regular,
    },
};
export var ArrowCollapseCHOpenIcon = forwardRef('ArrowCollapseCHOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
